import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { reviews } from '../../data/content';
export function Reviews() {
  return <section className="border-y border-edge bg-carbon" data-id="element-615" data-mp="2frllipng0vae">
      <div className="mx-auto max-w-shell px-5 py-16 sm:px-6 lg:px-10 lg:py-28" data-id="element-616" data-mp="2klpx5m7nlrht">
        <Reveal className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between" data-id="element-617" data-mp="2pk12pkqx1fu8">
          <h2 className="max-w-xl font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-chalk sm:text-4xl" data-id="element-618" data-mp="1su0g9se0rbg3">
            Gemiddeld een 4,9 uit 200+ beoordelingen
          </h2>
          <span className="flex gap-1" aria-label="5 van de 5 sterren" data-id="element-619" data-mp="21tnk0ku80tcb">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-ember text-ember" aria-hidden="true" data-id="element-620" data-mp="26u2vt7yutss6" data-mpi={i} />)}
          </span>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3" data-id="element-621" data-mp="3dbq4drpmngnu">
          {reviews.map((review, i) => <Reveal key={review.name} delay={i * 0.06} data-id="element-622" data-mp="v6lg1yi8z5ed" data-mpi={i}>
              <figure className="card-sheen flex h-full flex-col overflow-hidden rounded-2xl border border-edge bg-panel p-6 transition-colors duration-200 ease-smooth hover:border-ember/50" data-id="element-623" data-mp="v628nbq83zel">
                <blockquote className="text-[15px] leading-relaxed text-chalk/85" data-id="element-624" data-mp="m4lxv2vhxv9u">“{review.quote}”</blockquote>
                <figcaption className="mt-auto pt-6" data-id="element-625" data-mp="h6u7weeewj8a">
                  <span className="block font-medium text-chalk" data-id="element-626" data-mp="c89464zybhf3">{review.name}</span>
                  <span className="mt-1 block text-sm text-ember" data-id="element-627" data-mp="7hiwgl41z2h8">{review.car}</span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}